module.exports = __webpack_public_path__ + "static/media/Iconinsta.f469f143.svg";